<template>
  <div class="lp-cookies" v-if="!cookieSaved">
    <div class="lp-cookies__inner cia-container">
      <div class="lp-cookies__content">
        <img class="lp-cookies__icon" src="@/assets/icons/cookies.svg" />
        <p>Ta strona używa ciasteczek (cookies), dzięki którym nasz serwis może działać lepiej.</p>
      </div>
      <div class="lp-cookies__buttons">
        <ciaButton
          :title="'Dowiedz się więcej'"
          :click="goToPrivacyPolicy"
        >Dowiedz się więcej</ciaButton>
        <ciaButton
          :color="'blue'"
          :title="'Rozumiem'"
          :click="setCookies"
        >Rozumiem</ciaButton>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import ciaButton from './button.vue';

export default {
  name: 'cookies-lp',
  data: () => ({
    cookieSaved: true,
  }),
  components: {
    ciaButton,
  },
  methods: {
    verifyCookie() {
      this.cookieSaved = Cookies.get('cookie-info');
    },
    setCookies() {
      Cookies.set('cookie-info', true);
      this.cookieSaved = true;
    },
    goToPrivacyPolicy() {
      this.$router.push('/polityka-prywatnosci');
    },
  },
  mounted() {
    this.verifyCookie();
  },
};
</script>

<style lang="scss">
  .lp-cookies {
    position: fixed;
    box-shadow: 0 -3px 15px 0 rgba(0, 0, 0, 0.16);
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    background: #fff;
    padding: 0 20px;
    &__inner {
      position: relative;
    }
    p {
      font-size: 14px;
      font-weight: 300;
      padding: 20px 0 0 0;
      margin: 0;
      @media (min-width: 750px) {
        padding: 34px 0 0 0;
      }
    }
    &__content {
      position: relative;
      padding-left: 70px;
      min-height: 90px;
    }
    &__icon {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
      width: 48px;
      height: auto;
    }
    &__buttons {
      padding-bottom: 20px;
      padding-top: 20px;
      @media (min-width: 470px) {
        padding-top: 0;
      }
      @media (min-width: 1200px) {
        padding-bottom: 0;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
      .cia-button {
        @media (max-width: 469px) {
          display: block;
          width: 100%;
        }
        &:first-child {
          margin-bottom: 10px;
          @media (min-width: 470px) {
            margin-bottom: 0;
            margin-right: 16px;
          }
        }
      }
    }
  }
</style>
